/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PixtaCategory,
    PixtaCategoryFromJSON,
    PixtaCategoryFromJSONTyped,
    PixtaCategoryToJSON,
} from './PixtaCategory';

/**
 * PIXTAカテゴリ一覧取得APIのレスポンスデータ
 * @export
 * @interface GetPixtaCategorySuccessResponseData
 */
export interface GetPixtaCategorySuccessResponseData {
    /**
     * カテゴリ一覧
     * @type {Array<PixtaCategory>}
     * @memberof GetPixtaCategorySuccessResponseData
     */
    categories: Array<PixtaCategory>;
}

export function GetPixtaCategorySuccessResponseDataFromJSON(json: any): GetPixtaCategorySuccessResponseData {
    return GetPixtaCategorySuccessResponseDataFromJSONTyped(json, false);
}

export function GetPixtaCategorySuccessResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPixtaCategorySuccessResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'categories': ((json['categories'] as Array<any>).map(PixtaCategoryFromJSON)),
    };
}

export function GetPixtaCategorySuccessResponseDataToJSON(value?: GetPixtaCategorySuccessResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'categories': ((value.categories as Array<any>).map(PixtaCategoryToJSON)),
    };
}

